import "./App.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import About from "./component/about/About";
import Contact from "./component/contact/Contact";
import Footer from "./component/footer/Footer";
import Header from "./component/header/Header";
import Home from "./component/home/Home";
import Skills from "./component/skills/Skills";
import Work from "./component/work/Work";
import WorkEdit from "./component/work/WorkEdit";
import PrivateRoute from "./PrivateRoute";
import Login from "./component/auth/Login";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ScrollUp from "./scrollup/ScrollUp";
import React from "react";

function App() {
  const handleLogin = (email) => {
    window.location.href = "/"; // Redirect to home after login
  };

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <>
              <Header />
              <main className="main">
                <Home />
                <About />
                <Skills />
                <Work />
                <Contact />
                <Footer />
                <ScrollUp />
              </main>
            </>
          }
        />
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route
          path="/work/edit"
          element={
            <PrivateRoute>
              <WorkEdit />
            </PrivateRoute>
          }
        />
      </Routes>
            <ToastContainer />
    </Router>
  );
}

export default App;
